<template>
  <b-form-group
    label="Sıra No"
    label-for="ordering"
  >
    <validation-provider
      #default="{ errors }"
      name="Sıra No"
      rules="required"
    >
      <cleave
        id="phone"
        v-model="itemData.ordering"
        class="form-control"
        :raw="true"
        :options="options.ordering"
        placeholder="Giriniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup } from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'

export default {
  name: 'OrderingCategoriesCard',
  components: {
    Cleave,
    BFormGroup,
    ValidationProvider,
  },
  data() {
    return {
      options: {
        ordering: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['categories/dataItem']
    },
  },
}
</script>
